import { TimingRepeatType } from '../../model/schedulingModels/TimingRepeatType';
import { TimingWindow } from './TimingWindow';

export type RolloutTimingResult = {
  repeatType: TimingRepeatType;
  timingWindows: TimingWindow[];
};

const from = (timingWindows: TimingWindow[], repeatType: TimingRepeatType): RolloutTimingResult => ({
  repeatType,
  timingWindows,
});

export const RolloutTimingResult = { from };
